import { type ReactNode } from 'react';

export function EmptyState({ children, title }: { children?: ReactNode; title: string }) {
  return <section className="dd-empty-state"><h2>{title}</h2>{children}</section>;
}
